module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.name,
      class: {
        active: tab.isActive
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (tab.isActive),
        expression: "tab.isActive"
      }],
      key: tab.name,
      staticClass: "tab-pane"
    }, [_c('h3', [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(tab.content))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fbc9e64","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/DetailsTab.vue
// module id = 2496
// module chunks = 0